import { Box, Button, CircularProgress, Divider, Grid, MenuItem, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { getQtmCategories, getQuantumTemplates } from "api/services/quantum";
import DialogWrapper from "components/DialogWrapper";
import { snack } from "components/toast";
import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { DialogProps, ResType } from "types";
import { StyledServiceDesc, StyledServiceItem, StyledServicesContainer } from "views/services/SubtaskServices/styles";
import { vider_v } from "assets";
import { useParams } from "react-router-dom";
import SearchContainer from "components/SearchContainer";
import { getDefaultMetaTemplates } from "api/services/communication";
import { AxiosResponse } from "axios";

interface Props extends DialogProps {
    data: any;
    userData: any
}

function WhatsappTemplates() {
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const limit = 12;
    const offset = (page - 1) * limit;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    
const { data:templates, isLoading, error } = useQuery<AxiosResponse<any>>(
    'default-templates',
    getDefaultMetaTemplates,
);
console.log(templates,'templates')
    return (
       <>
            {/* <StyledServicesContainer> */}
                <Grid container spacing={2} padding={2}>
                    {templates?.data?.map((item: any, index: number) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                            <StyledServiceItem
                                // onClick={() => handleClick(item)}
                            >
                                <Box width="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <Box mb={1}>
                                        <Typography variant="h6" color="rgba(0,0,0,0.6)">
                                                {item.templateName}
                                            </Typography>
                                            <Box display="flex" justifyContent="space-between">

                                            <Typography variant="caption" color="rgba(0,0,0,0.6)">
                                                {item.body}
                                            </Typography>
                                        </Box>
    
                                    </Box>
                                  
                                </Box>
                            </StyledServiceItem>
                        </Grid>
                    ))}
                </Grid>
             
            {/* </StyledServicesContainer> */}
            


           
            </>
    );
}

export default WhatsappTemplates;